// Connects the docked pending question to the live composer without moving
// payload data across the registry boundary: the harness provides the
// composer and dismissal through this context, while the registry-rendered
// question view keeps ownership of the call id and the answer contract.
import { createContext, type ReactNode } from 'react';

export type QuestionDockComposerOptions = Readonly<{
    /** Submits the typed draft as the question's free-text answer. */
    readonly onSendText: (text: string) => Promise<boolean>;
    /** Question-specific placeholder; the harness supplies the default. */
    readonly placeholder?: string;
}>;

export type QuestionDock = Readonly<{
    readonly renderComposer: (
        options: QuestionDockComposerOptions,
    ) => ReactNode;
    /** Collapses the panel back to the question's transcript position. */
    readonly dismiss: () => void;
}>;

/** Present only around the single docked question in the composer footer. */
export const QuestionDockContext = createContext<QuestionDock | null>(null);
